var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('b-modal',{ref:"model_error",attrs:{"ok-only":"","title":"提示","ok-title":"确定"},on:{"ok":_vm.handleOk}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('b-modal',{ref:"model_ql",attrs:{"title":"提示","ok-title":"确定","ok-only":""}},[_c('p',[_vm._v("查询状态异常，请联系银行")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a7dc78c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qilubank/BaseQueryAction_ql.vue
// module id = null
// module chunks = 